import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Header.css'; // Импорт стилей
import xb from '../assets/xbillion.png'

const Header = ({ user, setUser }) => {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // Состояние для отображения меню

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    navigate('/auth');
  };

  const handleLogin = () => {
    navigate('/auth');
  };

  const navigateToHome = () => {
    navigate('/');
  };

  const navigateToUserAccount = () => {
    navigate('/admin-account');
  };

  // Функция для переключения состояния меню
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="logo-container" onClick={navigateToHome}>
        <img
          src={xb}
          alt="Логотип"
          className="logo"
        />
        
      </div>
      {/* Иконка бургер-меню */}
      <button
        className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
        onClick={toggleMenu}
      >
        {isMenuOpen ? '✖' : '☰'}
      </button>
      {/* Навигационное меню */}
      <nav className={`nav ${isMenuOpen ? 'open' : ''}`}>
        {user ? (
          <>
            <button className="glow-on-hover2" onClick={navigateToUserAccount}>
              Личный кабинет
            </button>
            <button className="glow-on-hover2" onClick={handleLogout}>
              Выйти
            </button>
          </>
        ) : (
          <button className="glow-on-hover2" onClick={handleLogin}>
            Войти
          </button>
        )}
      </nav>
    </header>
  );
};

export default Header;
